<div class="container" style="border:1px solid #bebaba">
  <div class="row">
    <div class="col-md-12">

      <a [routerLink]="['/login']">
        <img src="../../../assets/Desktop Class.png" class="img-responsive" style="width:100%; display: block; margin: 0 auto; width: 100%;">
      </a>

      <a [routerLink]="['/login']">
        <img src="../../../assets/main content1.png" class="img-responsive" style="width:100%; display: block; margin: 0 auto; width: 100%;">
      </a>

    </div>
  </div>
  <br />
  <br />
  <div class="row" style="margin-left:5%;margin-right:5%">
    <div class="col-md-12" style="text-align:justify; text-justify:distribute-all-lines; font-weight:bold">
      The information on this website is only a summary of the terms of the Settlement. For more detailed information, please review the
      <a href="~/docs/CourtDocsCargill/Turkey - Cargill-Long Form Notice.pdf" target="_blank">Long Form Notice</a>
      and/or the  <a href="~/docs/CourtDocsCargill/Long form settlement agreement with Cargill.pdf" target="_blank">Settlement Agreement</a>.<br /><br />

      If you are a Settlement Class Member, your legal rights will be affected by this Settlement whether you act or do not act.<br /><br />

      <b>
        If you purchased any Turkey product directly from a Turkey producer for use or delivery in the United States from January 1, 2010, through January 1,
        2017, a class action settlement may affect your rights. * Please see page 8 of the <a href="~/docs/CourtDocsCargill/Long form settlement agreement with Cargill.pdf" target="_blank">Settlement Agreement</a> for the full definition of “Turkey”.
      </b><br /><br />

      <ul>
        <li>
          A new Settlement Agreement (“Settlement” or “Cargill Settlement”) has been reached in a class action antitrust lawsuit filed on behalf of Direct Purchaser Plaintiffs with Cargill, Incorporated and Cargill Meat Solutions Corporation (“Cargill” or “Settling Defendant”).
        </li>
        <br />
        <li>
          If approved by the Court, the Cargill Settlement will resolve the claims in the lawsuit about whether Cargill combined and conspired in restraint of trade, the purpose and effect of which was to suppress competition and to allow Cargill and other Turkey producers to charge supra-competitive prices for Turkey products during the Settlement Class Period, in violation of federal law. If approved, the Settlement will avoid litigation costs and risks to Direct Purchaser Plaintiffs and Cargill and will release Cargill from liability to members of the Settlement Class.
        </li>
        <br />
        <li>
          Direct Purchaser Plaintiffs have reached this Settlement with Cargill, and a previous settlement with Tyson, but the Direct Purchasers Plaintiffs’ case is proceeding against other Defendants. Those other Defendants may be subject to separate settlements, judgments, or class certification orders.
        </li>
        <br />
        <li>
          The Settlement requires Cargill to pay $32,500,000. In addition to this monetary payment, Cargill has agreed to respond to specific requests made by the Direct Purchaser Plaintiffs in their continued prosecution of the litigation.
        </li>
        <br />
        <li>
          The Court has not decided whether Cargill did anything wrong, and Cargill denies any wrongdoing.
        </li>
        <br />
        <li>
          To be eligible to receive a payment from the Cargill Settlement and the prior settlement with Tyson, you must complete and submit a timely Claim Form by April 21, 2025.
        </li>
        <li>
          Your legal rights are affected whether you act or don’t act. Please read carefully.
        </li>
      </ul>
    </div>
  </div>
  <div class="panel-heading" style="background-color: #27451c; color: white; text-align:center">
    <h2><b>Important Dates</b></h2><br />
  </div>
  <div class="panel-heading" style="background-color: black; color: white; text-align:center; font-weight:bold">
    <div class="row">
      <div class="col-md-2">
        Exclusion Deadline<br />
        Deadline Passed
      </div>
      <div class="col-md-4">
        Objection Deadline<br />
        Deadline Passed
      </div>
      <div class="col-md-4">
        Court Hearing Date<br />
        June 18, 2025
      </div>
      <div class="col-md-2">
        Claim Filing Deadline<br />
        Deadline Passed
      </div>
    </div>
  </div>
  <br />
  <br />
  <div class="row" style="margin-left:5%;margin-right:5%; margin-top:3%">
    <div class="col-md-12">
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th colspan="3" style="background-color: #0e3870; color: #ffffff; font-weight: bold; font-size: 2.0em; text-align: center;">
                YOUR LEGAL RIGHTS AND OPTIONS IN THIS SETTLEMENT
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style=" background-color:#eff2f5; text-align:center; font-weight:bold; color:#1e4953; vertical-align: middle; width:25%">
                FILE A CLAIM TO RECEIVE MONEY FROM THE SETTLEMENTS
              </td>
              <td style="background-color:white; color:#3e4144; width:50%">
                In order to receive money from the Cargill and Tyson Settlements you must submit a Claim Form by April 21, 2025. <b style="color:red">The deadline to file a claim has passed</b>.
              </td>

            </tr>
            <tr>
              <td style=" background-color:#eff2f5; text-align:center; font-weight:bold; color:#1e4953; vertical-align: middle; width:25%">
                ASK TO BE EXCLUDED
              </td>
              <td style="background-color:white; color:#3e4144; width:50%">
                This is the only option that allows you ever to be part of any <b><i>other</i></b> lawsuit against Cargill about the Released Claims (as defined in the
                <a href="~/docs/CourtDocsCargill/Long form settlement agreement with Cargill.pdf" target="_blank">Settlement Agreement</a>).
                Requests for Exclusion must be postmarked or received by April 21, 2025. <b style="color:red">The deadline to request exclusion has passed</b>.
              </td>

            </tr>
            <tr>
              <td style=" background-color:#eff2f5; text-align:center; font-weight:bold; color:#1e4953; vertical-align: middle; width:25%">
                OBJECT
              </td>
              <td style="background-color:white; color:#3e4144; width:50%">
                Write to the Court about why you do not like the Settlement. Objections must be postmarked or received by April 21, 2025. <b style="color:red">The deadline to file an objection has passed</b>.
              </td>
            </tr>
            <tr>
              <td style=" background-color:#eff2f5; text-align:center; font-weight:bold; color:#1e4953; vertical-align: middle; width:25%">
                ATTEND THE
                FAIRNESS HEARING
              </td>
              <td style="background-color:white; color:#3e4144; width:50%">
                Ask to speak in Court about the fairness of the Settlement. <b style="color:red">The deadline to file a Notice of intention to appear has passed</b>.
              </td>
            </tr>
            <tr>
              <td style=" background-color:#eff2f5; text-align:center; font-weight:bold; color:#1e4953; vertical-align: middle; width:25%">
                DO NOTHING
              </td>
              <td style="background-color:white; color:#3e4144; width:50%">
                If you do not file a claim, you will receive no payment from the Settlements.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <br />
  <br />
  <div class="row" style="margin-left: 5%; margin-right: 5%; text-align: justify; text-justify: distribute-all-lines">
    <div class="col-md-12 ">
      <span style="font-weight:bold; text-decoration:underline; font-size:1.3em">Class Definition—You May Be Part of the Class</span><br /><br />

      The Court decided that, for settlement purposes, members of the Settlement Class are defined as:
      <br /><br />

      <b>
        All persons who purchased Turkey directly from any of the Defendants or any co­conspirator, or their respective subsidiaries or affiliates, for use or delivery in the United States
        from at least as early as January 1, 2010, until January 1, 2017. * Please see page 8 of the <a href="~/docs/Certified/" target="_blank">Settlement Agreement</a> for the full definition of “Turkey”.
      </b><br /><br />

      <span style="font-weight:bold; text-decoration:underline; font-size:1.3em">The Settlement Benefits</span><br /><br />

      If the Settlement is approved, Cargill will pay $32,500,000 into a Settlement fund to resolve all Released Claims that Settlement Class members ever had, now have, or may ever have against the Cargill Released Parties (all as defined in the <a href="~/docs/CourtDocsCargill/Long form settlement agreement with Cargill.pdf" target="_blank">Settlement Agreement</a>). In addition to this monetary benefit, Cargill has also agreed to respond to specific requests made by the Direct Purchaser Plaintiffs in their continued prosecution of the litigation.
      <br /><br />


      <span style="font-weight:bold; text-decoration:underline; font-size:1.3em">How to Get a Payment</span><br /><br />

      To be eligible to receive a payment from any of the Cargill and Tyson Settlements, you must complete and submit a timely Claim Form by April 21, 2025. <b style="color:red">The deadline to file a claim has passed</b>.<br /><br />

      <span style="font-weight:bold; text-decoration:underline; font-size:1.3em">The Settlement Hearing</span><br /><br />

      The Court will hold a hearing to decide whether to approve the Settlement (the “Fairness Hearing”). You may attend and you may ask to speak, but you don’t have to. The Court will hold a Fairness Hearing on June 18, 2025, at 10:00 a.m. Central. The hearing will be conducted by video conference. A telephone call-in number is also available: (855) 244-8681 and the access code is 2319 163 9975##. At this hearing, the Court will consider whether the Settlement is fair, reasonable, and adequate. If there are objections, the Court will consider them. The Court will listen to people who have asked to speak at the hearing. After the hearing, the Court will decide whether to approve the Settlement and the request for litigation expenses. We do not know how long these decisions will take.<br /><br />
      The Court will hold the Fairness Hearing remotely via telephone or video conference and may change call-in details or move the Fairness Hearing to a later date without providing additional notice to members of the Settlement Class. Updates will be posted to this Website.
      <br /><br />


      <span style="font-weight:bold; text-decoration:underline; font-size:1.3em">Further Information</span><br /><br />

      This website and the <a href="~/docs/CourtDocsCargill/Turkey - Cargill-Long Form Notice.pdf" target="_blank">Notice</a> summarize the Settlement. For more details regarding this Settlement, please reference the <a href="~/docs/CourtDocsCargill/Long form settlement agreement with Cargill.pdf" target="_blank">Settlement Agreement</a> or other documents filed in the case under the “Court Documents” link above. You may also contact the Settlement Administrator for further information regarding this Settlement.
      <br /><br />

      <span style="font-weight:bold; text-decoration:underline; font-size:1.3em">Settlement Administrator</span><br /><br />


      <div class="row">
        <div class="col-md-12 text-center">
          Turkey Antitrust Litigation<br />
          c/o A.B. Data, Ltd.<br />
          P.O. Box 173015<br />
          Milwaukee, WI  53217<br />
          877-777-9637<br />
          E-mail:  <a href="mailto:info@TurkeyLitigation.com">info@TurkeyLitigation.com</a><br />
        </div>
      </div>
      <br /><br />
      If you have questions, you may call the Turkey Antitrust Litigation Helpline at 877-777-9637 or email <a href="mailto:info@TurkeyLitigation.com">info@TurkeyLitigation.com</a>.
    </div>
  </div>
  <br />
  <div class="row">
    <div class="col-md-12">
      <a>
        <img src="../../../assets/people graphic.png" class="img-responsive" style="width:100%; display: block; margin: 0 auto; width: 100%;">
      </a>

    </div>
  </div>
</div>


